import bootstrapper from '../../bootstrapper';
import currentAcademicInstitution from './academicInstitutions.js.erb';

const isWholesiesConsentUpdateEnabled = () =>
  bootstrapper.wholesiesConsentUpdate && Boolean(currentAcademicInstitution());

export default isWholesiesConsentUpdateEnabled;
